export default {
  init() {
    var blocks = document.querySelectorAll('.pb-awards-sections');
    if (!blocks.length) return;

    var getHeaderH = function () {
      var siteHeader = document.querySelector('.nav-wrap');
      return siteHeader ? siteHeader.offsetHeight : 0;
    };

    Array.prototype.forEach.call(blocks, function (block) {
      var inner = block.querySelector('.pb-awards-sections__inner');
      var navWrap = block.querySelector('.pb-awards-sections__nav-wrap');
      var navLinks = Array.prototype.slice.call(
        block.querySelectorAll('.pb-awards-sections__nav-link')
      );

      var select = block.querySelector('.pb-awards-sections__select');

      if (!inner || !navWrap || (!navLinks.length && !select)) return;

      // Spacer to prevent layout jump when nav becomes fixed
      var spacer = document.createElement('div');
      spacer.className = 'pb-awards-sections__nav-spacer';
      spacer.style.height = '0px';
      navWrap.parentNode.insertBefore(spacer, navWrap);

      // Resolve sections
      var sectionEls = [];
      navLinks.forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var target = block.querySelector(href) || document.querySelector(href);
        if (target) sectionEls.push(target);
      });

      // Dropdown change (mobile)
      if (select) {
        select.addEventListener('change', function () {
          var id = select.value;
          if (!id) return;

          var target = block.querySelector('#' + id) || document.querySelector('#' + id);
          if (!target) return;

          var headerH = getHeaderH();
          var isMobile = window.matchMedia('(max-width: 1023px)').matches;
          var extra = isMobile ? 36 : 20;
          var offset = headerH + navWrap.offsetHeight + extra;

          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      }


      // Smooth scroll
      navLinks.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var id = a.getAttribute('href');
          if (!id || id.charAt(0) !== '#') return;

          var target = block.querySelector(id) || document.querySelector(id);
          if (!target) return;

          e.preventDefault();

          var headerH = getHeaderH();
          var isMobile = window.matchMedia('(max-width: 1023px)').matches;
          var extra = isMobile ? 36 : 20;
          var offset = headerH + navWrap.offsetHeight + extra;

          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
      });

      // Active state
      var setActive = function (id) {
        navLinks.forEach(function (a) {
          a.classList.toggle('is-active', a.getAttribute('href') === ('#' + id));
        });

        if (select) select.value = id;
      };


      var onScrollActive = function () {
        if (!sectionEls.length) return;

        var headerH = getHeaderH();
        var isMobile = window.matchMedia('(max-width: 1023px)').matches;
        var extra = isMobile ? 46 : 30;
        var markerY = window.pageYOffset + headerH + navWrap.offsetHeight + extra;


        var active = null;
        for (var i = 0; i < sectionEls.length; i++) {
          var sec = sectionEls[i];
          var top = sec.getBoundingClientRect().top + window.pageYOffset;
          if (top <= markerY) active = sec;
        }
        if (active && active.id) setActive(active.id);
      };

      // Fixed pin until end
      var navOrigTop = null;

      var computeOrigTop = function () {
        navOrigTop = navWrap.getBoundingClientRect().top + window.pageYOffset;
      };
      computeOrigTop();

      var pinNav = function () {
        var headerH = getHeaderH();
        block.style.setProperty('--pb-awards-sticky-top', headerH + 'px');

        var scrollY = window.pageYOffset;
        var navH = navWrap.offsetHeight;
        block.style.setProperty('--pb-awards-nav-h', navH + 'px');

        var innerTop = inner.getBoundingClientRect().top + scrollY;
        var innerBottom = innerTop + inner.offsetHeight;

        // Recompute original top if layout changed
        if (navOrigTop === null) computeOrigTop();

        var start = navOrigTop - headerH;         // when to start fixing
        var end = innerBottom - navH - headerH;   // when to dock at bottom

        if (scrollY < start) {
          // normal flow
          navWrap.style.position = 'relative';
          navWrap.style.top = 'auto';
          navWrap.style.bottom = 'auto';
          navWrap.style.left = 'auto';
          navWrap.style.right = 'auto';
          navWrap.style.width = 'auto';
          spacer.style.height = '0px';
          navWrap.classList.remove('is-stuck-end');
          return;
        }

        spacer.style.height = navH + 'px';

        if (scrollY >= end) {
          // dock to bottom of module
          navWrap.classList.add('is-stuck-end');
          navWrap.style.position = 'absolute';
          navWrap.style.top = 'auto';
          navWrap.style.bottom = '0';
          navWrap.style.left = '0';
          navWrap.style.right = '0';
          navWrap.style.width = '100%';
        } else {
          // fixed to viewport under header
          navWrap.classList.remove('is-stuck-end');
          navWrap.style.position = 'fixed';
          navWrap.style.top = headerH + 'px';
          navWrap.style.left = '0';
          navWrap.style.right = '0';
          navWrap.style.width = '100%';
          navWrap.style.bottom = 'auto';
        }
      };

      var onResize = function () {
        // reset then recompute to avoid drift
        navOrigTop = null;
        spacer.style.height = '0px';
        navWrap.style.position = 'relative';
        navWrap.style.top = 'auto';
        navWrap.style.bottom = 'auto';
        navWrap.style.left = 'auto';
        navWrap.style.right = 'auto';
        navWrap.style.width = 'auto';
        computeOrigTop();
        pinNav();
        onScrollActive();
      };

      window.addEventListener('scroll', pinNav, { passive: true });
      window.addEventListener('scroll', onScrollActive, { passive: true });
      window.addEventListener('resize', onResize);

      // init
      pinNav();
      onScrollActive();

      // re-measure after the browser restores scroll + layout settles
      requestAnimationFrame(function () {
        navOrigTop = null;
        pinNav();
        onScrollActive();

        requestAnimationFrame(function () {
          navOrigTop = null;
          pinNav();
          onScrollActive();
        });
      });

      setTimeout(function () {
        onResize();
      }, 250);
    });
  },

  finalize() {},
};
